import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import SEO, { SITE_URL } from './components/SEO/SEO';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import './styles/global.css';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'ExploitEye',
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  description:
    'ExploitEye is a digital Solutions provider building secure, scalable web applications, mobile apps, and cybersecurity solutions — including VAPT, digital marketing, and workflow automation — for ambitious businesses across India.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Chennai',
    addressRegion: 'Tamil Nadu',
    postalCode: '600001',
    addressCountry: 'IN',
  },
  telephone: '+91-89405-51811',
  email: 'info@exploiteye.in',
  areaServed: 'IN',
  sameAs: [],
  makesOffer: [
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Web Development' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'App Development' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Automation & Integrations' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Digital Marketing' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Cyber Security Consulting (VAPT)' } },
  ],
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <SEO jsonLd={organizationJsonLd} />
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}